import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import FmDirectoryEditService from 'app/admin/fileManager/service/FmDirectoryEditService';
import { withRouter, useParams } from 'react-router';

const config = data => {
	return {
		key: 'fmDirectoryEditForm',
		text: 'Mappa',
		textKey: 'fmDirectoryEditForm',
		service: FmDirectoryEditService,
		defaultValue: () =>
			new Promise((resolve, reject) => {
				FmDirectoryEditService.create().then(response => {
					resolve({
						...response,
						...{
							parentDirectory: data.directory !== '0' ? data.directory : null,
							parentStorage: data.storage
						}
					});
				});
			}),
		fields: [
			{
				key: 'fileName',
				text: 'Név',
				textKey: 'fileName',
				component: EditFormTextField,
				required: true
			}
		]
	};
};

function FmDirectoryEditForm() {
	const { directory, storage } = useParams();
	const myConfig = config({
		directory,
		storage
	});

	return <EditFormPage config={myConfig} />;
}

export default withRouter(FmDirectoryEditForm);
